import {
  RadioCard,
  RadioDot,
  RadioGroup,
} from '@/components/ui/radio-group.tsx';
import { ConsentType } from '@/features/dashboard/consentTemplates/types/ConsentTemplateType.ts';
import { consentTypeChoices } from '@/features/dashboard/consentTemplates/types/ConsentTemplateType.utils.ts';

interface ConsentTypeStepProps {
  value: ConsentType;
  onChange: (type: ConsentType) => void;
}

/** Pierwszy krok dodawania zgody: czym ta zgoda w ogóle jest. */
const ConsentTypeStep = ({ value, onChange }: ConsentTypeStepProps) => (
  <RadioGroup
    aria-label="Rodzaj zgody"
    value={value}
    onValueChange={(next) => onChange(next as ConsentType)}
    className="gap-2.5"
  >
    {consentTypeChoices.map((choice) => (
      <RadioCard
        key={choice.value}
        value={choice.value}
        className="block w-full border border-neutral-200 bg-neutral-50 px-4 py-3.5 data-[state=checked]:border-accent-600 data-[state=checked]:bg-basic-white data-[state=checked]:shadow-[0_0_0_2px_theme(colors.accent-200)] data-[state=unchecked]:hover:border-neutral-300"
      >
        <span className="flex items-center gap-[11px]">
          <RadioDot />
          <choice.icon
            aria-hidden
            className="size-[18px] shrink-0 text-neutral-500 group-data-[state=checked]:text-accent-700"
          />
          <span className="text-sm font-bold text-ink">{choice.label}</span>
        </span>
        <span className="mt-1.5 block text-pretty pl-[27px] text-[13px] leading-normal text-neutral-600">
          {choice.description}
        </span>
      </RadioCard>
    ))}
  </RadioGroup>
);

export default ConsentTypeStep;
